import { html, css } from 'lit-element';
import { BaseElement } from './BaseElement';
import { API, EVENT_TYPES } from '../API';
import { DIALOG_TYPE_ERROR } from './ModalDialog';
import * as GUID from '../GUID';
import { PatientVideos as _PatientVideos } from '../PatientVideos';

import './PatientVideo';

const _videos = Symbol();
const _api = Symbol();
const _statusHandler = Symbol();

class PatientVideos extends BaseElement {
	constructor() {
		super();

		this[_statusHandler] = () => {
			if(this.api.loggedIn && !this.videos && this.api.isPhysician)
				this.getPatientVideos();
			else if(!this.api.loggedIn)
				this.questions = null;
			this.requestUpdate();
		};
	}
	static get styles() {
		return [
			...BaseElement.styles,
			css`
				:host {
					display: block;
				}
				legend {
					padding: 0 0.5em;
					border-bottom: none;
					font-weight: bold;
				}
				.videos {
					display: flex;
					flex-flow: row wrap;
				}
				.videos pp-patient-video {
					flex: 1 0;
					min-width: 15em;
					// max-width: 15em;
					border: var(--theme-border, black);
					background: var(--theme-secondary, white);
					border-radius: 0.25em;
					margin: 0.25em;
				}
			`
		];
	}
	get api() {
		return this[_api];
	}
	set api(v) {
		if(v !== null && !(v instanceof API))
			throw new TypeError('api must be an instance of API.');
		this[_api] = v;
	}
	get videos() {
		return this[_videos];
	}
	set videos(v) {
		if(v !== null && !(v instanceof _PatientVideos))
			throw new TypeError('videos must be an instance of PatientVideos.');
		this[_videos] = v;
		this.requestUpdate();
	}
	async getVideos() {
		const id = GUID.newGUID();
		try {
			this.emit('show-busy', id);
			if(!this.api)
				throw new Error('no api set.');
			this.videos = await this.api.patientVideos();
			const ids = await this.api.doctorPatientVideoIds();
			[...this.shadowRoot.querySelectorAll('pp-patient-video')].forEach(v => {
				v.checked = ids.indexOf(v.video.patientVideoId) >= 0;
			});
			this.emit('hide-busy', id);
		}
		catch(err) {
			this.emit('hide-busy', id);
			this.emit('show-dialog', {
				title: 'Patient Videos',
				message: err.message,
				type: DIALOG_TYPE_ERROR
			});
		}
	}
	async checkHandler(e) {
		try {
			const { video, checked } = e.target;

			if(checked)
				await this.api.addPatientVideo(video.patientVideoId);
			else
				await this.api.removePatientVideo(video.patientVideoId);
		}
		catch(err) {
			this.emit('show-dialog', {
				title: 'Patient Video Error',
				message: err.message,
				type: DIALOG_TYPE_ERROR
			});
		}
	}
	connectedCallback() {
		super.connectedCallback();

		this.emit('get-api', { callback: api => this.api = api });
		this.api.on(EVENT_TYPES.EVENT_TYPE_LOGIN_STATUS, this[_statusHandler]);
		
		if(this.api.loggedIn && this.api.isPhysician)
			this.getVideos();
	}
	disconnectedCallback() {
		super.disconnectedCallback();

		this.api.off(null, this[_statusHandler]);
		this.api = null;
	}
	render() {
		return html`
			<fieldset>
				<legend>Patient Videos</legend>
				<p class="info">
					<i class="icon fas fa-info-circle"></i>
					Select the exercise videos you would like your patients to see.
				</p>
				<div class="videos">
					${this.videos ? [...this.videos].map(v => html`
						<pp-patient-video @check="${(e) => this.checkHandler(e)}" .video="${v}" .api="${this.api}"></pp-patient-video>
					`) : ''}
				</div>
			</fieldset>
		`;
	}
}

customElements.define('pp-patient-videos', PatientVideos);